import web from "@/core/middlewares/web";
import prefix from "@/core/utils/prefix-routes";

let statistics = () => import(/* webpackChunkName: "reports" */ '@/views/reports/Statistics');

export default [
    ...prefix("/reports",[
            {
                path: "statistics",
                name: "reports.statistics",
                component: statistics,
                meta: {
                    middleware: web,
                    permissions: ['reports:viewer'],
                    title: "گزارش آمار بازدید"
                }
            },
        ])
    ]